export default "__VITE_ASSET__97ad3515__"